// on top of your index.android.js file
const isHermesEnabled = !!global.HermesInternal;  // this line is only needed if you don't use an .android.js file

// in your view.js file
if( isHermesEnabled ) {
	
	// https://formatjs.io/docs/polyfills/intl-datetimeformat/#default-timezone
	if ('__setDefaultTimeZone' in Intl.DateTimeFormat) {
		Intl.DateTimeFormat.__setDefaultTimeZone(
			require("expo-localization").timezone
		);
	}
}
